import { render, staticRenderFns } from "./AccountLisCreate.vue?vue&type=template&id=0a6df5d4"
import script from "./AccountLisCreate.vue?vue&type=script&lang=js"
export * from "./AccountLisCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports